<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-body p-4 login-form w-100">                       
                        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" >
                            <div class="m-4 position-relative">
                                <label class="mb-1 text-dark">Old Password<span class="text-danger">*</span></label>
                                <div class="position-relative">
                                    <input type="password" class="form-control" placeholder="Old Password" formControlName="old_password" [type]="old_password_hide_show ? 'text' : 'password'">
                                    <span class="show-pass eye" (click)="oldPasswordHide()" [ngClass]="{'active':old_password_hide_show}">
                                        <i class="fa fa-eye-slash"></i>
                                        <i class="fa fa-eye"></i>
                                    </span>
                                </div>
                                <div *ngIf="resetForm?.get('old_password')?.invalid && resetForm?.get('old_password')?.touched" class="required">
                                    Old password is required
                                </div>
                            </div>
                            <div class="m-4 position-relative">
                                <label class="mb-1 text-dark">New Password<span class="text-danger">*</span></label>
                                <div class="position-relative">
                                  <input type="password" class="form-control" [type]="hide_show ? 'text' : 'password'" placeholder="abc@12345" formControlName="password">
                                  <span class="show-pass eye" (click)="passwordHide()" [ngClass]="{'active':hide_show}">
                                      <i class="fa fa-eye-slash"></i>
                                      <i class="fa fa-eye"></i>
                                  </span>                  
                              </div>
                              <div *ngIf="password?.invalid && password?.touched" class="required">
                                <small *ngIf="password?.errors?.['required']"> Password is required </small>
                                <small *ngIf="password?.errors?.['minlength']"> Min length is 6 </small>
                                <small *ngIf="password?.errors?.['pattern']"> Must contain a number & special character </small>                
                            </div>
                              </div>
                              <div class="m-4 position-relative">
                                <label class="mb-1 text-dark">Confirm Password<span class="text-danger">*</span></label>
                                <div class="position-relative">
                                  <input type="password" class="form-control" [type]="confirm_hide_show ? 'text' : 'password'" placeholder="abc@12345" formControlName="confirmPassword">
                                  <span class="show-pass eye" (click)="confirmPasswordHide()" [ngClass]="{'active':confirm_hide_show}">
                                      <i class="fa fa-eye-slash"></i>
                                      <i class="fa fa-eye"></i>
                                  </span>                  
                              </div>              
                            <div *ngIf="confirmPassword?.invalid || resetForm.errors?.['passwordMismatch']" class="required">
                                <small *ngIf="confirmPassword?.errors?.['required'] && resetForm?.get('confirmPassword')?.touched">Confirm Password is required</small>
                                <small *ngIf="!confirmPassword?.errors?.['required'] && resetForm?.errors?.['passwordMismatch'] && resetForm?.get('confirmPassword')?.touched"> Passwords do not match</small>
                            </div>
                              </div>
                              <div class="col-md-2 text-center mb-4 ms-2">
                                <button type="submit" class="btn btn-primary btn-sm" [disabled]="resetForm.invalid || loadingService.isLoading()">Submit</button>
                              </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>